import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { WarningIcon } from "./warningIcon";
import { Props } from "./types";
import styles from "./styles.scss";

const BAND_CLASSES: { [key: string]: string } = {
  OK: styles.ok,
  WARN: styles.warn,
  OVER: styles.over,
  NONE: styles.none,
};

function Cell(props: Props) {
  const { t } = useTranslation();
  const isOverload = props.period.occupancy < 0;

  return (
    <div
      className={classNames(styles.cell, BAND_CLASSES[props.period.band])}
      title={isOverload ? t("occupancyPage.table.overload") : undefined}
    >
      {isOverload ? (
        <WarningIcon className={styles.warningIcon} />
      ) : (
        <p className={styles.value}>
          {props.period.occupancy.toLocaleString(props.locale)}
          {" %"}
        </p>
      )}
    </div>
  );
}

export { Cell };
